export default __webpack_public_path__ + "static/media/information.28bce70c.png";